import React from 'react'
import styled from 'styled-components'
import { PAGE_PATH } from '@laputan/core'
import { Link } from '../../components/Link'
import { getUrlWithQueryString } from '../../helpers/UtilHelper'
import { STYLES } from '../../static/style'
import { BackIcon } from '../../components/Icon/BackIcon'

const StyledBackToSearch = styled.div`
  padding: 0.5rem 0;
  font-weight: ${STYLES.FONT_WEIGHT_BOLD};
`

const BackToSearchLink = styled(Link)`
  display: flex;
  align-items: center;
`

const BackToSearch = () => (
  <StyledBackToSearch>
    <BackToSearchLink to={`${getUrlWithQueryString(PAGE_PATH.SCHOOL_SEARCH)}`}>
      <BackIcon />
      Back
    </BackToSearchLink>
  </StyledBackToSearch>
)

export { BackToSearch }
